import * as Sentry from "@sentry/react";

export const loggerService = () => {
    const environment = process.env.VITE_NODE_ENV || "local";
    const isEnabled = environment !== "local";
    const dsn = process.env.VITE_SENTRY_DSN;

    // Only log if there's an issue
    if (!dsn) {
        console.warn("[Sentry] DSN not configured - error tracking disabled");
        return;
    }

    try {
        Sentry.init({
            dsn,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.browserProfilingIntegration(),
                Sentry.featureFlagsIntegration(),
                Sentry.feedbackIntegration({
                    // Additional SDK configuration goes in here, for example:
                    colorScheme: "system",
                    triggerLabel: "Report an Issue",
                    formTitle: "Report an Issue",
                    submitButtonLabel: "Submit",
                }),
                Sentry.replayIntegration({
                    maskAllText: true,
                    blockAllMedia: true,
                }),
            ],
            skipBrowserExtensionCheck: true,
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
            tracesSampleRate: 1.0,
            tracePropagationTargets: [
                "localhost",
                /^https:\/\/(.*\.)?1digitalstack\.ai$/,
            ],
            environment,
            release: `${__APP_NAME__}@${__APP_VERSION__}`,
            enabled: isEnabled,
            profilesSampleRate: 1.0,
            allowUrls: [/https?:\/\/(.*\.)?1digitalstack\.ai/],

            // Log only when events are actually sent (for debugging)
            beforeSend(event) {
                if (process.env.NODE_ENV !== "production") {
                    console.log("[Sentry] Capturing error:", event.event_id);
                }
                return event;
            },
        });

        // Verify initialization succeeded
        const client = Sentry.getClient();
        if (!client) {
            console.error(
                "[Sentry] Failed to initialize - try disabling browser extensions"
            );
        }
    } catch (error: any) {
        console.error("[Sentry] Initialization error:", error?.message);
    }
};
